import {
    buildConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import { selectWidgetInstanceState } from 'widgets/store/selectors';
import State from 'store/State';
import { WidgetWithTabTitleState } from './WidgetConfigWithTabTitle';
import { combineReducers } from 'redux';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { WidgetConfigWithTabTitle } from 'widgets/tabTitle/WidgetConfigWithTabTitle';

const initialState: WidgetConfigWithTabTitle = {};

const slice = (widgetType: WidgetType) =>
    buildConfigSlice(
        widgetType,
        (state: State, widgetKey: string) =>
            selectWidgetInstanceState(state, widgetType, widgetKey),
        initialState
    );

const widgetWithTabTitleWidgetReducer = (widgetType: WidgetType) =>
    combineReducers<WidgetWithTabTitleState>({
        config: slice(widgetType).reducer,
    });

export type WidgetWithTabTitleWidgetConfigPayloadType =
    WidgetConfigSliceActionPayloadType<WidgetWithTabTitleState>;

export const widgetWithTabTitleWidgetsReducer = (widgetType: WidgetType) =>
    createWidgetsReducer<
        WidgetWithTabTitleState,
        WidgetWithTabTitleWidgetConfigPayloadType
    >(widgetType, widgetWithTabTitleWidgetReducer(widgetType));
